export default function processFinishVsFailureData(results, statusIdMap, didFinish) {
    return Object.entries(results.reduce((acc, r) => {
        var _a;
        const status = (_a = statusIdMap[r.statusId]) === null || _a === void 0 ? void 0 : _a.status;
        if (status) { //if our data is loaded
            if (didFinish(status)) { //if this result finished
                acc.Finished++; //increment the finished count
            }
            else {
                acc["Did Not Finish"]++; //else increment the DNF count
            }
        }
        return acc;
    }, { Finished: 0, "Did Not Finish": 0 })).map(([key, value]) => ({
        keys: [key],
        label: key,
        values: [value],
    }));
}
